<!-- 采购退货单记录 -->
<template>
  <div class="pagePadding">
    <Form inline class="formMarginBtm20 clearfix">
      <!-- 订单号 -->
      <FormItem>
        <span>订单号：</span>
        <Select placeholder="请选择" v-model="queryFrom.dept_id" clearable filterable class="iviewIptWidth250">
          <Option v-for="(item, index) in thirdList" :value="item.dept_id" :key="index">{{ item.dept_name }}</Option>
        </Select>
      </FormItem>
      <!-- 供应商名称 -->
      <FormItem class="marginLeft40">
        <span>供应商名称：</span>
        <Select placeholder="请选择" v-model="queryFrom.dept_id" clearable filterable class="iviewIptWidth250">
          <Option v-for="(item, index) in thirdList" :value="item.dept_id" :key="index">{{ item.dept_name }}</Option>
        </Select>
      </FormItem>
      <!-- 下单时间 -->
      <FormItem class="marginLeft40">
        <span>下单时间：</span>
        <DatePicker type="daterange" placeholder="请选择" format="yyyy-MM-dd" class="iviewIptWidth250"></DatePicker>
      </FormItem>
      <!-- 按钮 -->
      <FormItem class="po-create-number marginRight0" :label-width="20">
        <span class="pageBtn finger btnSure">查询</span>
        <span class="pageBtn finger btnReset marginLeft20">新增</span>
      </FormItem>
    </Form>
    <Table :productList="listColumns" :productData="listData"></Table>
  </div>
</template>

<script>
import Table from '@/components/table'

export default {
  name: 'purchaseReturnRecord',
  components: {
    Table,
  },
  data() {
    return {
      // 表格数据
      listData: [
        {
          id: 'CG202008040001',
          name: '波科国际医疗贸易(上海)有限公司',
          warehouse: '武汉仓',
          data: '2022-08-01 20:01:02',
          person: '玛卡巴卡',
        },
        {
          id: 'CG202008040001',
          name: '波科国际医疗贸易(上海)有限公司',
          warehouse: '武汉仓',
          data: '2022-08-01 20:01:02',
          person: '玛卡巴卡',
        },
      ],
      // 表格头部标题
      listColumns: [
        {
          title: '序号',
          type: 'index',
          align: 'center',
          width: 55,
        },
        {
          title: '订单号',
          key: 'id',
          align: 'center',
        },
        {
          title: '供应商名称',
          key: 'name',
          align: 'center',
        },
        {
          title: '下单时间',
          key: 'data',
          align: 'center',
        },
        {
          title: '操作',
          align: 'center',
          width: 189,
          render: (h, param) => {
            return h('div', [
              h(
                'span',
                {
                  style: {
                    color: '#389AFC',
                    fontSize: '14px',
                    cursor: 'pointer',
                  },
                  on: {
                    click: () => {
                      this.details(param.row)
                    },
                  },
                },
                '详情'
              ),
              h(
                'span',
                {
                  style: {
                    color: '#389AFC',
                    fontSize: '14px',
                    cursor: 'pointer',
                    marginLeft: '40px',
                  },
                  on: {
                    click: () => {
                      // this.details(param.row)
                    },
                  },
                },
                '导出'
              ),
            ])
          },
        },
      ],
      // 表单拉下选项
      thirdList: [],
      // 查询参数
      queryFrom: {
        user_id: '',
        user_name: '',
        dept_id: '',
        subfamily_id: '',
      },
    }
  },
  methods: {
    // 详情
    details(row) {
      this.$router.push({
        path: '/detailsPurchaseReturnRecord',
      })
    },
  },
}
</script>

<style scoped lang="less"></style>
